import React from "react";
import { connect } from "react-redux";
import SideNav from "components/layout-components/SideNav";
import TopNav from "components/layout-components/TopNav";
import MobileNav from "components/layout-components/MobileNav";
import HeaderNav from "components/layout-components/HeaderNav";
import PageHeader from "components/layout-components/PageHeader";
import Footer from "components/layout-components/Footer";
import AppViews from "views/app-views";
import SorteioMensalidadeModal from "components/shared-components/SorteioMensalidadeModal";
import SorteioResultadoModal from "components/shared-components/SorteioResultadoModal";
import CortesiaFimModal from "components/shared-components/CortesiaFimModal";
import FlipPendenteModal from "components/shared-components/FlipPendenteModal";
import NovoNumeroWhatsAppModal from "components/shared-components/NovoNumeroWhatsAppModal";
import ComunidadeNovoGrupoModal from "components/shared-components/ComunidadeNovoGrupoModal";
import PreferenciasModaisProvider from "components/shared-components/PreferenciasModais";
import TermosUsoModal from "components/shared-components/TermosUsoModal";
// import LivePromoModal from "components/shared-components/LivePromoModal";
import { Layout, Grid } from "antd";

import navigationConfig from "configs/NavigationConfig";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
	SIDE_NAV_WIDTH,
	SIDE_NAV_COLLAPSED_WIDTH,
	NAV_TYPE_SIDE,
	NAV_TYPE_TOP,
	DIR_RTL,
	DIR_LTR,
} from "constants/ThemeConstant";
import utils from "utils";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout = ({ navCollapsed, navType, location, direction }) => {
	const currentRouteInfo = utils.getRouteInfo(
		navigationConfig,
		location.pathname,
	);
	const screens = utils.getBreakPoint(useBreakpoint());
	const isMobile = !screens.includes("lg");
	const isNavSide = navType === NAV_TYPE_SIDE;
	const isNavTop = navType === NAV_TYPE_TOP;
	const isInicioRapido = location.pathname === `${APP_PREFIX_PATH}/inicio-rapido`;
	const getLayoutGutter = () => {
		if (isNavTop || isMobile || isInicioRapido) {
			return 0;
		}
		return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH;
	};

	const getLayoutDirectionGutter = () => {
		if (direction === DIR_LTR) {
			return { paddingLeft: getLayoutGutter() };
		}
		if (direction === DIR_RTL) {
			return { paddingRight: getLayoutGutter() };
		}
		return { paddingLeft: getLayoutGutter() };
	};

	return (
		<Layout>
			<TermosUsoModal />
			<PreferenciasModaisProvider>
				<ComunidadeNovoGrupoModal />
				<NovoNumeroWhatsAppModal />
			</PreferenciasModaisProvider>
			<SorteioMensalidadeModal />
			<SorteioResultadoModal />
			<CortesiaFimModal />
			<FlipPendenteModal />
			{/* <LivePromoModal /> */}
			{isNavTop && !isMobile ? (
				<TopNav routeInfo={currentRouteInfo} />
			) : null}
			<Layout className="app-container">
				{isNavSide && !isMobile && !isInicioRapido ? (
					<SideNav routeInfo={currentRouteInfo} isMobile={isMobile} />
				) : null}
				<Layout
					className="app-layout"
					style={getLayoutDirectionGutter()}
				>
					<HeaderNav isMobile={isMobile} hideMenuToggle={isInicioRapido} />
					<div
						className={`app-content ${
							isNavTop ? "layout-top-nav" : ""
						}`}
					>
						<PageHeader
							display={currentRouteInfo?.breadcrumb}
							title={currentRouteInfo?.title}
						/>
						<Content>
							<AppViews />
						</Content>
					</div>
					<Footer />
				</Layout>
			</Layout>
			{isMobile && !isInicioRapido && <MobileNav />}
		</Layout>
	);
};

const mapStateToProps = ({ theme }) => {
	const { navCollapsed, navType, locale } = theme;
	return { navCollapsed, navType, locale };
};

export default connect(mapStateToProps)(React.memo(AppLayout));
